/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Add_ActionInputs */

const cs_automation_add_action = /** @type {(inputs: Automation_Add_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat akci`)
};

const en_automation_add_action = /** @type {(inputs: Automation_Add_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add action`)
};

/**
* | output |
* | --- |
* | "Add action" |
*
* @param {Automation_Add_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_add_action = /** @type {((inputs?: Automation_Add_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Add_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_add_action(inputs)
	return cs_automation_add_action(inputs)
});